/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { OrderRetrieveResponse } from '../types/OrderRetrieve';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type OrdersRetrieveRequest = {} | null | undefined;
export type OrdersRetrieveResponse = OrderRetrieveResponse;

export type OrdersRetrieveQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this order.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * GET /dmx-server/orders/{id}/
 *
 * ```yaml
 * operationId: orders_retrieve
 * tags:
 *   - orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderRetrieve'
 *     description: ''
 * ```
 */
export const ordersRetrieveOperation = ({ id, ...rest }: OrdersRetrieveQuery) =>
  ({
    method: 'GET',
    path: `/dmx-server/orders/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/orders/{id}/' };
  };

/**
 * GET /dmx-server/orders/{id}/
 *
 * ```yaml
 * operationId: orders_retrieve
 * tags:
 *   - orders
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderRetrieve'
 *     description: ''
 * ```
 */
export const ordersRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: OrdersRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderRetrieveResponse>> => {
  const operation = ordersRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/orders/{id}/
 */
export const useOrdersRetrieveResource = (
  query: OrdersRetrieveQuery | null,
  useCached?: boolean,
): UseResource<OrdersRetrieveResponse> => {
  return useResource<OrdersRetrieveResponse>({
    path: query === null ? null : ordersRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
